const accordionItems = document.querySelectorAll('.accordion__item .trigger');

accordionItems.forEach((item) => {
	item.addEventListener('click', () => {
		item.closest('.accordion__item').classList.toggle('active');
		item.classList.toggle('h2');
	});
});
